import React, { useMemo, useState } from "react";
import { getDailyChallenge } from "../../modules/play/engine";
import { playGamesMock } from "../../modules/play/mock";
import { DailyChallengeCard, MiniGameContainer } from "../../modules/play/components";
import { AttentionSelectiveExercise } from "../../modules/pratiquer/Cognitif/AttentionSelectiveExercise";

// Play · Défis : défi du jour mock + placeholders futurs.
export default function PlayDefis() {
  const challenge = useMemo(() => getDailyChallenge(), []);
  const game = challenge ? playGamesMock.find((g) => g.id === challenge.gameId) : undefined;
  const [showDemo, setShowDemo] = useState(false);

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Play · Défis</h1>
        <p className="text-sm md:text-base text-slate-600 dark:text-slate-300">
          Mode défi du jour (mock). Les scores et classements arriveront plus tard.
        </p>
      </header>

      {challenge && (
        <section className="space-y-3">
          <DailyChallengeCard
            challenge={challenge}
            game={game}
            onPlay={() => setShowDemo(true)}
          />
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Pour l'instant, le défi lance un mini-jeu démo (attention sélective). Les scores ne sont pas sauvegardés.
          </p>
        </section>
      )}

      {showDemo && game && (
        <MiniGameContainer game={game} onBack={() => setShowDemo(false)}>
          {game.id === "play-attention-1" ? (
            <AttentionSelectiveExercise />
          ) : (
            <p className="text-sm text-slate-600 dark:text-slate-300">Mini-jeu bientôt disponible.</p>
          )}
        </MiniGameContainer>
      )}

      <section className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {[
          { title: "Score & progression", desc: "Historique des défis et badges (à venir)." },
          { title: "Classements", desc: "Comparer tes scores (à venir)." },
          { title: "Défis thématiques", desc: "Défis par catégorie (à venir)." },
        ].map((item) => (
          <div
            key={item.title}
            className="mm-surface p-4"
          >
            <h2 className="text-lg font-semibold mb-1">{item.title}</h2>
            <p className="text-sm text-slate-600 dark:text-slate-300">{item.desc}</p>
          </div>
        ))}
      </section>
    </div>
  );
}

